import moment from 'moment';
//import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
        await this.GetAllPaymentMethods();
        this.GetAllFinancialsWithdrawing();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  حركات المحافظ ',
            ScreenTitleSingle: '  حركة   ',
            ScreenTitleSingleAl: ' حركة  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            From: '',
            To:'',
            FilterBy:1,
            PaymentMethodsId:'',
            WithdrawingId:'',
            Operation:'',

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },

            // WAL-18 / UI-18 — Manual wallet transaction modal state.
            // ManualTx mirrors the body the (still-missing) endpoint will
            // accept; ManualTxMissing flips true if the POST 404s so the
            // operator sees a friendly notice instead of an axios stack.
            ManualTxOpen: false,
            ManualTxMissing: false,
            ManualTxOk: false,
            ManualTxSaving: false,
            ManualTx: {
                WalletId: null,
                Type: 1,       // 1=Credit, 2=Debit
                Amount: null,
                Reason: ''
            },

            // WAL-09 / UI-14 — Approve / Reject confirmation modals.
            // Replaces the plain confirm()/prompt() calls with proper
            // RTL Arabic dialogs matching the rest of the panel.
            ApproveOpen: false,
            ApproveSaving: false,
            RejectOpen: false,
            RejectSaving: false,
            ActionItem: null,    // the withdrawal row currently being acted on
            RejectReason: '',
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                    this.To = this.ChangeDate(this.To);

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetWithdrawingTracker(this.pageNo, this.pageSize, this.Search, this.From, this.To,
                this.PaymentMethodsId, this.WithdrawingId, this.Operation)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        ChangeFilter(id) {
            this.FilterBy = id;
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
        },


        Refresh() {
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
            this.From = '';
            this.To = '';
            this.GetInfo();
        },

        // -------- WAL-09 / UI-14: Approve / Reject pending withdrawals --------
        OpenApprove(item) {
            this.ActionItem = item;
            this.ApproveOpen = true;
        },
        CloseApprove() {
            this.ApproveOpen = false;
            this.ActionItem = null;
        },
        async ConfirmApprove() {
            const item = this.ActionItem;
            if (!item) return;
            const txId = item.walletTransactionId || item.id;
            if (!txId) return;
            this.ApproveSaving = true;
            try {
                await this.$http.ApproveWithdraw(txId);
                if (this.$helper && this.$helper.SuccessMessage) {
                    this.$helper.SuccessMessage('تم اعتماد طلب السحب');
                }
                this.ApproveOpen = false;
                this.ActionItem = null;
                this.GetInfo(this.pageNo);
            } catch (e) {
                const msg = (e && e.response && e.response.data && (e.response.data.Message || e.response.data.Code)) || 'تعذّر اعتماد طلب السحب';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                else alert(msg);
            } finally {
                this.ApproveSaving = false;
            }
        },

        OpenReject(item) {
            this.ActionItem = item;
            this.RejectReason = '';
            this.RejectOpen = true;
        },
        CloseReject() {
            this.RejectOpen = false;
            this.ActionItem = null;
            this.RejectReason = '';
        },
        async ConfirmReject() {
            const item = this.ActionItem;
            if (!item) return;
            const txId = item.walletTransactionId || item.id;
            if (!txId) return;
            this.RejectSaving = true;
            try {
                await this.$http.RejectWithdraw(txId, this.RejectReason || 'بدون سبب محدد');
                if (this.$helper && this.$helper.SuccessMessage) {
                    this.$helper.SuccessMessage('تم رفض طلب السحب');
                }
                this.RejectOpen = false;
                this.ActionItem = null;
                this.RejectReason = '';
                this.GetInfo(this.pageNo);
            } catch (e) {
                const msg = (e && e.response && e.response.data && (e.response.data.Message || e.response.data.Code)) || 'تعذّر رفض طلب السحب';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                else alert(msg);
            } finally {
                this.RejectSaving = false;
            }
        },

        // -------- WAL-18 / UI-18: Manual wallet transaction (admin-only) --------
        OpenManualTx() {
            this.ManualTx = { WalletId: null, Type: 1, Amount: null, Reason: '' };
            this.ManualTxMissing = false;
            this.ManualTxOk = false;
            this.ManualTxOpen = true;
        },

        CloseManualTx() {
            this.ManualTxOpen = false;
        },

        async SubmitManualTx() {
            if (!this.ManualTx.WalletId || !this.ManualTx.Amount) return;
            this.ManualTxSaving = true;
            this.ManualTxOk = false;
            this.ManualTxMissing = false;
            try {
                await this.$http.CreateManualWalletTransaction({
                    WalletId: this.ManualTx.WalletId,
                    ProcessType: this.ManualTx.Type, // 1=Credit, 2=Debit
                    Amount: this.ManualTx.Amount,
                    Reason: this.ManualTx.Reason || 'حركة يدوية من الإدارة'
                });
                this.ManualTxOk = true;
                setTimeout(() => { this.ManualTxOpen = false; this.GetInfo(this.pageNo); }, 800);
            } catch (e) {
                const code = e?.response?.status;
                if (code === 404 || code === 405) {
                    this.ManualTxMissing = true;
                } else {
                    const msg = e?.response?.data?.Message || e?.response?.data?.Code || 'تعذّر تنفيذ الحركة';
                    if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                    else alert(msg);
                }
            } finally {
                this.ManualTxSaving = false;
            }
        }

    }
}
